<template>
  <div class="foot_page">
    <div class="top_box dis_f fle_t">
      <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
      <img src="@/assets/img/com_txt.png" class="top_txt" alt>
      <div class="banner_box">
        <van-swipe class="w100 h100" indicator-color="#F00000" :autoplay="3000">
          <van-swipe-item class="dis_f ali_ct jus_ct">
            <div class="banner_list">
              <p class="banner_zh">1. 活动期间购买澳大利亚葡萄酒</p>
              <p class="banner_en">Purchase Australian wine during the promotion</p>
            </div>
          </van-swipe-item>
          <van-swipe-item class="dis_f ali_ct jus_ct">
            <div class="banner_list">
              <p class="banner_zh">2. 保存您的小票或订单截图</p>
              <p class="banner_en">Screenshot your purchase receipt</p>
            </div>
          </van-swipe-item>
          <van-swipe-item class="dis_f ali_ct jus_ct">
            <div class="banner_list">
              <p class="banner_zh">3. 上传个人信息及购买凭证</p>
              <p class="banner_en">Submit your details and proof of purchase</p>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="dis_f fle_t ali_ct w100 fle_no">
        <div class="box_txt fle_no">
          已经剁手了澳大利亚葡萄酒？
          <br>赶快上传购买凭证加入惊喜大奖抽奖池！
        </div>
        <!-- <div @click="clickBegin('upload','上传购物凭证')" class="test_btn1"></div> -->
        <router-link tag="div" class="test_btn1" data-name="上传购物凭证" to="upload"></router-link>
        <div class="w100 fle_no">
          <img src="@/assets/img/begin_show.png" class="begin_show" alt>
        </div>
        <router-link tag="div" class="test_btn2" data-name="开始测试" to="test/"></router-link>
        <!-- <div @click="clickBegin('/test/','开始测试')" class="test_btn2"></div> -->
      </div>
      <div class="fl1"></div>
      <!-- <div class="foot_txt">活动条款及细则</div> -->
      <img
        @click="showAgreement=true"
        src="@/assets/img/begin_txt.png"
        class="begin_txt fle_no"
        alt
      >
      <AgeerementBox v-model="showAgreement"/>
    </div>
  </div>
</template>

<script>
import AgeerementBox from "@/components/Ageerement";
export default {
  components: {
    AgeerementBox
  },
  data() {
    return {
      showAgreement: false
    };
  },
  created() {
    this.$store.commit("setStoreData", {
      name: "testData",
      data: []
    });
    sessionStorage.removeItem("sl");
  }
};
</script>

<style lang="scss" scoped>
.foot_page {
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background: #000;
  .top_box {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    overflow-y: auto;
    .top_txt {
      height: 57px;
      width: 131px;
      margin: 30px 0;
      margin-left: 30px;
    }
    .banner_box {
      width: 631px;
      height: 225px;
      margin: 0 auto;
      border: 10px solid #f00000;
      .banner_list {
        // width: 100%;
        // padding-left: 20px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        .banner_zh {
          color: #ffffff;
          font-size: 35px;
          line-height: 60px;
          white-space: nowrap;
        }
        .banner_en {
          // padding-left: 30px;
          font-size: 25px;
          color: #ffffff;
          white-space: nowrap;
        }
      }
    }
    .box_txt {
      margin-top: 30px;
      text-align: center;
      font-size: 35px;
      line-height: 80px;
      color: rgba(255, 255, 255, 0.92);
    }
    .show_title {
      padding-top: 130px;
      padding-bottom: 80px;
      text-align: center;
      line-height: 80px;
      color: rgba(255, 255, 255, 1);
      font-size: 60px;
    }
    .show_txt {
      width: 100%;
      height: 100%;
      padding-bottom: 50px;
      overflow-y: auto;
      p {
        flex-shrink: 0;
        font-size: 35px;
        line-height: 80px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .test_btn1 {
      width: 457px;
      height: 133px;
      background: url("~@/assets/img/begin_btn2.png") no-repeat center;
      background-size: contain;
      margin-top: 30px;
      margin-bottom: 40px;
      flex-shrink: 0;
    }
    .test_btn2 {
      width: 313px;
      height: 75px;
      background: url("~@/assets/img/begin_btn1.png") no-repeat center;
      background-size: contain;
      margin-top: 50px;
      flex-shrink: 0;
    }
    .foot_txt {
      font-size: 30px;
      line-height: 52px;
      color: rgba(255, 255, 255, 0.8);
      text-decoration: underline;
    }
    .begin_show {
      height: 276px;
    }
    .begin_txt {
      width: 255px;
      margin: 52px auto 33px;
    }
  }
}
</style>
